// src/app/slices/coilSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CoilState, ICoil, ICoilParams, IIdNameValue } from '../models';

const initialState: CoilState = {
  coils: {},
  coil_params: null,
  conn_hands: []
};

const coilSlice = createSlice({
  name: 'coil',
  initialState,
  reducers: {
    setCoil: (state, action: PayloadAction<ICoil>) => {
      state.coils[action.payload.id] = {
        ...action.payload,
        params: action.payload.coil_params
          ? JSON.parse(action.payload.coil_params)
          : '',
      };
    },
    setCoilParams: (state, action: PayloadAction<ICoilParams>) => {
      state.coil_params = action.payload;
    },
    setConnHands: (state, action: PayloadAction<IIdNameValue[]>) => {
      state.conn_hands = action.payload;
    },
  },
});

export const { setCoil, setCoilParams, setConnHands } = coilSlice.actions;

export default coilSlice.reducer;
